/* ============
 * Add multiple pdf turnover via email modal
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';
import reportService from './../../services/report';
import Forms from './../../utils/forms/forms';
export default {
  props: {
    selected: {
      type: Array,
      required: true,
      default: () => [],
    },
    emailData: {
      type: Object,
      required: true,
      default: () => [],
    },
    noData: {
      type: Array,
      required: false,
      default: () => [],
    },
    noDataAllSelected: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    period: {
      type: String,
      required: false,
      default: () => '',
    },
    additionalData: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      form: new Forms({
        from: {
          value: '',
          type: 'select',
        },
        subject: {
          value: this.emailData.subject,
          type: 'text',
        },
        message: {
          value: this.emailData.message,
          type: 'textarea',
        },
      }),
      selectedClients: [],
      loading: false,
      submitLoading: false,
      submitted: false,
      errors: [],
      result: [],
    };
  },
  computed: {
    //
  },

  mounted() {
    if (this.noData.length === 0) {
      this.form.setOptions('from', [{
        id: { email: this.emailData.from.id, name: this.emailData.from.name },
        name: `${this.emailData.from.name}(${this.emailData.from.id})`,
      }]);
      this.form.setFieldValue('from', { email: this.emailData.from.id, name: this.emailData.from.name });

      this.selectedClients = this.selected.map(c => ({
        id: c.id,
        name: c.name,
        emails: c.emails,
        email: c.emails.split(',')[0] || '',
        lastSent: c.turnoverLastSent,
      }));
    }
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),
    handleSend() {
      this.submitLoading = true;
      reportService
        .sendTurnOverPdf({
          clients: this.selectedClients.map(c => ({ id: c.id, email: c.email })),
          from_email: this.form.from.email,
          from_name: this.form.from.name,
          subject: this.form.subject,
          message: this.form.message,
          sendTurnOver: 1,
          selectedYear: this.emailData.selectedYear,
        })
        .then((response) => {
          this.submitted = true;
          this.result = response.data.statuses;
          this.submitLoading = false;
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  watch: {
    //
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkProcessTurnOverModal/bulkProcessTurnOverModal.js